import { Button, Collapse, Icon, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { Component } from 'react'
import { I18n } from 'react-i18next'

import { Link } from 'react-router-dom'
import { i18nKeys } from '../../../app.i18n'
import { isBlank, isEmpty } from '../../utils/lang'
import { SpinnerLoader } from '../spinner-loader'
import { UserAvatar } from '../user-avatar'
import { PersonPanelOrgItem } from './person-panel-orgperson.component'

import { links } from '../../../app.links'
import { identity, OrgChartDto, UserViewGetDto } from '../../../shared'
import './person-panel.scss'

type Props = {
  selectedUser: UserViewGetDto
  personHierarchy: OrgChartDto[]
  canUploadPhoto?: boolean
  onUploadDialog?(): void
}

export class PersonPanel extends Component<Props> {
  public state = {
    isOpen: false,
  }

  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { canUploadPhoto = false, selectedUser, personHierarchy, children, onUploadDialog = identity } = this.props

    if (isBlank(selectedUser)) {
      return <SpinnerLoader />
    }

    return (
      <I18n>
        {(t) => (
          <div className="person-panel">
            <div className="person-panel__basic-information">
              {canUploadPhoto ? (
                <div className="person-panel__avatar" onClick={onUploadDialog}>
                  <UserAvatar imageSource={selectedUser.imageUrls.thumb144} userName={selectedUser.userDisplayName} />
                  <div className="photo-upload">
                    <div className="photo-upload__button">
                      {/* Icon alternatives: Camera, Export, Cloud: upload, upload */}
                      <Icon icon={IconNames.CLOUD_UPLOAD} title={false} />
                      <span>{t(i18nKeys.core.common.uploadPhoto)}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="person-panel__avatar">
                  <Link to={links.admin.persons.detail(selectedUser.personId)} className="">
                    <UserAvatar imageSource={selectedUser.imageUrls.thumb144} userName={selectedUser.userDisplayName} />
                  </Link>
                </div>
              )}

              <div className="person-panel__user-info">
                <h3>{selectedUser.userDisplayName}</h3>
                <div className="person-panel__function">{selectedUser.division}</div>
                <div className="person-panel__department">{selectedUser.department}</div>
              </div>
            </div>

            {children}

            {!isEmpty(personHierarchy) && (
              <>
                <div className="personal-panel__orgchart-controls">
                  <span className="person-panel__orgchart">{t(i18nKeys.shared.personPanel.orgChart)}</span>
                  <Button
                    minimal
                    intent={Intent.PRIMARY}
                    icon={
                      <Icon
                        iconSize={21}
                        icon={this.state.isOpen ? IconNames.CHEVRON_UP : IconNames.CHEVRON_DOWN}
                        title={false}
                      />
                    }
                    className="person-panel__orgchart-button"
                    onClick={this.handleClick}
                    data-test="collapse-button"
                  />
                </div>
                <div>
                  <Collapse isOpen={this.state.isOpen}>
                    <ul className="person-panel__orgchart__list person-panel__orgchart-mobile d-sm-block">
                      {personHierarchy.map((person, index) => (
                        <PersonPanelOrgItem
                          key={`p-${person.id}`}
                          personDisplayName={person.displayName}
                          personFunction={person.division || person.function}
                          isLast={index === personHierarchy.length - 1}
                        />
                      ))}
                    </ul>
                  </Collapse>
                  <ul className="person-panel__orgchart__list d-none d-sm-block">
                    {personHierarchy.map((person, index) => (
                      <PersonPanelOrgItem
                        key={`p-${person.id}`}
                        personDisplayName={person.displayName}
                        personFunction={person.division || person.function}
                        isLast={index === personHierarchy.length - 1}
                      />
                    ))}
                  </ul>
                </div>
              </>
            )}
          </div>
        )}
      </I18n>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/person-panel/person-panel.component.tsx